import { makeStyles } from "@mui/styles";

const portfolioStyle = makeStyles((theme) => ({
  row: {
    flexDirection: "row",
  },
  reversed: {
    flexDirection: "row-reverse !important",
  },
  boldText: {
    fontWeight: "600 !important",
    fontSize: "2rem !important",
  },
  hrLine: {
    height: "3px",
    width: "60px",
    backgroundColor: "#008374",
    margin: "0px auto",
  },
  portfolioCard: {
    backgroundColor: "#fff",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    overflow: "hidden",
    "&.MuiBox-root .card-content": {
      padding: "25px 20px",
    },
    "&.MuiBox-root .MuiTypography-h6": {
      fontWeight: "600",
    },
    "&.MuiBox-root .MuiTypography-body1": {
      fontSize: "14px !important",
      color: "#6c757d",
    },
  },
  tabs: {
    "&.MuiBox-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "&.MuiBox-root .MuiTabs-root .MuiTabs-fixed .MuiTabs-indicator ": {
      position: "relative !important",
    },
    "&.MuiBox-root .MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainer .Mui-selected":
      {
        color: "#008374 !important",
      },
    "&.MuiBox-root .MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainer": {
      flexWrap: "wrap ",
    },
    "&.MuiBox-root .MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainer .MuiTab-textColorPrimary":
      {
        padding: "0px 10px !important",
        textTransform: "capitalize !important",
        fontSize: "18px !important",
        fontWeight: "500 !important",
        color: "#000",
        minWidth: "0px !important",
        [theme.breakpoints.down(600)]: {
          fontSize: "15px !important",
          padding: "0px 6.5px !important",
        },
        "&:hover": {
          color: "#008374",
        },
      },
  },
  dialogeStyle: {
    "&.MuiDialog-root .MuiDialog-scrollPaper": {
      backgroundColor: "rgb(0,0,0,0.9)",
    },
    "&.MuiDialog-root .MuiDialog-scrollPaper .MuiPaper-elevation": {
      backgroundColor: "transparent !important",
      maxHeight: "none !important",
      maxWidth: "760px !important",
      margin: "0px !important",
    },
    "&.MuiDialog-root .MuiDialog-scrollPaper .MuiPaper-elevation .MuiBox-root":
      {
        position: "fixed",
        right: "3%",
        top: "3%",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgb(255,255,255,0.1)",
        transition: "0.3s",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgb(255,255,255,0.2)",
        },
      },
  },

  linksButton: {
    "&.MuiButton-root": {
      padding: "10px 15px !important",
      borderRadius: "50px !important",
      boxShadow: " 0 0 15px rgb(0 0 0 / 8%) !important",
      background: "#008374",
      border: "2px solid rgba(255, 255, 255, 0.1) !important",
      letterSpacing: "1px !important",
      fontWeight: "500 !important",
      textTransform: "capitalize !important",
      fontSize: "12px",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.5) !important",
        backgroundColor: "#008374",
      },
    },
  },
}));

export default portfolioStyle;
